function clear() {
  localStorage.clear()
}
function set(props) {
  let session = JSON.parse(localStorage.getItem('session')) || {}
  session = { ...session, ...props }
  localStorage.setItem('session', JSON.stringify(session))
  return session
}
function get(...props) {
  const session = JSON.parse(localStorage.getItem('session'))
  if (session) {
    if (!props.length) return session
    else if (props.length === 1) return session[props]
    else
      return props.reduce((ac, prop) => {
        ac = { ...ac, [prop]: session[prop] }
        return ac
      }, {})
  }
}
function isAuthenticated() {
  const isAuthenticated = get('isAuthenticated')
  return isAuthenticated || false
}
function isGuest() {
  const isGuest = get('isGuest') || null
  return isGuest || false
}
function isAdmin() {
  const roleId = get('roleId')
  return roleId < 5 || false
}
function isLogged() {
  return isGuest() || isAuthenticated()
}
const localStorageService = {
  clear,
  set,
  get,
  isAdmin,
  isAuthenticated,
  isGuest,
  isLogged,
}

export default localStorageService
